module.exports = __webpack_public_path__ + "img/deleteIcon.3188046d.svg";